module.exports = __webpack_public_path__ + "img/datacenter9.bb9d2be5.png";